import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { BlogPost } from '../models/blogpost';
import { ReturnStatement } from '../../../node_modules/@angular/compiler';

@Injectable({
  providedIn: 'root'
})

export class BlogService {

    constructor(private http: HttpClient) {}

    public getAll(page, perPage): Observable<iHttpPaginatedResponse> {
        return this.http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/blog?page=${page}&pp=${perPage}`).pipe(
            map(res => {
                let posts=[];
                res.data.forEach(post=>{
                    post.summary = post.body.replace(/<(?:.|\n)*?>/gm, '');
                    var trimmedString = post.summary.substr(0, 200);
                    post.summary = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))+'...';
                    if(post.tile_image && post.tile_image != 'NULL') post.tile_image=environment.apiEndpoint+'/storage/blog/'+post.tile_image;
                    if(post.header_image && post.header_image != 'NULL') post.header_image=environment.apiEndpoint+'/storage/blog/'+post.header_image;
                    posts.push(new BlogPost(post));
                })
                res.data = posts;
                return res;
            })
        );
    }

    public getPost(id): Observable<BlogPost> {
        return this.http.get<BlogPost>(environment.apiEndpoint + `/api/blog/${id}`).pipe(
            map(res => {
                res.summary = res.body.replace(/<(?:.|\n)*?>/gm, '').replace(/^(.{200}[^\s]*).*/, "$1")+'...';
                if(res.tile_image && res.tile_image != 'NULL') res.tile_image=environment.apiEndpoint+'/storage/blog/'+res.tile_image;
                if(res.header_image && res.header_image != 'NULL') res.header_image=environment.apiEndpoint+'/storage/blog/'+res.header_image;
                if(res.completions.length) res.completions=res.completions[0];
                return new BlogPost(res);
            })
        );
    }

    public getLatest(limit:number): Observable<BlogPost[]> {
      return this.http.get<BlogPost[]>(environment.apiEndpoint + '/api/blog/latest/'+limit).pipe(
        map(
          res => {
            let posts=[];
            res.forEach(post=>{
              post.summary = post.body.replace(/<(?:.|\n)*?>/gm, '');
              var trimmedString = post.summary.substr(0, 200);
              post.summary = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))+'...';
              if(post.tile_image && post.tile_image != 'NULL') post.tile_image=environment.apiEndpoint+'/storage/blog/'+post.tile_image;
              if(post.header_image && post.header_image != 'NULL') post.header_image=environment.apiEndpoint+'/storage/blog/'+post.header_image;
              posts.push(new BlogPost(post));
            })
            res=posts;
            return res;
          }
        )
      );
    }

    public getRandom(count): Observable<BlogPost[]> {
        return this.http.get<BlogPost[]>(environment.apiEndpoint + `/api/blog/random/${count}`).pipe(
            map(res => {
                let posts=[];
                res.forEach(post=>{
                    post.summary = post.body.replace(/<(?:.|\n)*?>/gm, '');
                    var trimmedString = post.summary.substr(0, 200);
                    post.summary = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))+'...';
                    if(post.tile_image && post.tile_image != 'NULL') post.tile_image=environment.apiEndpoint+'/storage/blog/'+post.tile_image;
                    if(post.header_image && post.header_image != 'NULL') post.header_image=environment.apiEndpoint+'/storage/blog/'+post.header_image;
                    posts.push(new BlogPost(post));
                })
                res = posts;
                return res;
            })
        );
    }

    public logPostCDP(id:number):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/blog/cpd', {postId:id}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}
